export const WithdrawalMessages = {
    UnavailableAccountFromCash: {
        key: 'UnavailableAccountFromCash',
        message: 'Account From cash is unavailable.'
    },
    AccountFromNotEnoughMoney: {
        key: 'AccountFromNotEnoughMoney',
        message: 'Account From hasn\'t enough money.'
    },
    GetAccountFailed: {
        key: 'GetAccountFailed',
        message: 'Account information is currently unavailable.'
    },
    CashBalancesFailed: {
        key: 'CashBalancesFailed',
        message: 'Can\'t load balances of account.'
    },
    RegisterBankWithdrawalFailed: {
        key: 'RegisterBankWithdrawalFailed',
        message: 'Withdrawal failed.'
    },
    RegisterBankWithdrawalSucceed: {
        key: 'RegisterBankWithdrawalSucceed',
        message: 'Withdrawal is successfully created.'
    },
    RegisterInternalWithdrawalFailed: {
        key: 'RegisterInternalWithdrawalFailed',
        message: 'Internal withdrawal failed.'
    },
    RegisterInternalWithdrawalSucceed: {
        key: 'RegisterInternalWithdrawalSucceed',
        message: 'Internal withdrawal is successfully created.'
    },
    CanFindCorrectPaymentMethod: {
        key: 'CanFindCorrectPaymentMethod',
        message: 'Withdrawal method mismatch.'
    }
};
